import { BsTypeH1, BsTypeH2 } from "react-icons/bs";

const toolbarGroups = [
  [
    {
      id: 1,
      format: "fontFamily",
      type: "dropdown",
      options: [
        { text: "Default", value: `` },
        { text: "Auckland Hills", value: "AucklandHills" },
      ],
    },
    {
      id: 1,
      format: "lineHeight",
      type: "dropdown",
      options: [
        { text: "Default", value: "default" },
        { text: "0.7", value: "0.7" },
        { text: "0.8", value: "0.8" },
        { text: "0.9", value: "0.9" },
        { text: "1", value: "1" },
        { text: "1.1", value: "1.1" },
        { text: "1.2", value: "1.2" },
        { text: "1.3", value: "1.3" },
        { text: "1.4", value: "1.4" },
      ],
    },
    {
      id: 2,
      format: "fontSize",
      type: "fontSize",
      options: [
        { text: "16px", value: "16px" },
        { text: "18px", value: "18px" },
        { text: "24px", value: "24px" },
        { text: "30", value: "30px" },
      ],
    },
  ],
  [
    {
      id: 3,
      format: "bold",
      type: "mark",
    },
    {
      id: 4,
      format: "italic",
      type: "mark",
    },
    {
      id: 5,
      format: "underline",
      type: "mark",
    },
    {
      id: 6,
      format: "strikethrough",
      type: "mark",
    },
  ],
  [
    {
      id: 7,
      format: "color",
      type: "color-picker",
    },
    {
      id: 8,
      format: "bgColor",
      type: "color-picker",
    },
  ],

  [
    {
      id: 11,
      format: "headingOne",
      type: "block",
      Icon: BsTypeH1,
    },
    {
      id: 12,
      format: "headingTwo",
      type: "block",
      Icon: BsTypeH2,
    },
    {
      id: 13,
      format: "headingThree",
      type: "block",
    },
    {
      id: 14,
      format: "blockquote",
      type: "block",
    },
  ],
  [
    {
      id: 15,
      format: "orderedList",
      type: "block",
    },
    {
      id: 16,
      format: "unorderedList",
      type: "block",
    },
  ],
  [
    {
      id: 17,
      format: "alignLeft",
      type: "block",
    },
    {
      id: 18,
      format: "alignCenter",
      type: "block",
    },
    {
      id: 19,
      format: "alignRight",
      type: "block",
    },
  ],
  [
    {
      id: 20,
      format: "link",
      type: "link",
    },
  ],

  [
    {
      id: 24,
      type: "inTable",
    },
  ],
];

export default toolbarGroups;
